import { convertUnit, MediaSize } from "../../../common";
export function autoCropCanvas(arg) {
    const { imgSize, canvas } = arg;
    let { padding } = arg;
    if (!padding) {
        padding = {
            unit: "mm",
            name: "padding",
            width: 10, height: 10,
        };
    }
    const img_w = convertUnit(imgSize.unit, imgSize.width, "600dpi");
    const img_h = convertUnit(imgSize.unit, imgSize.height, "600dpi");
    const { isLandscape, sizeName } = determinPaperSize(imgSize);
    const paper = MediaSize[sizeName];
    const paper_w = convertUnit(paper.unit, isLandscape ? paper.height : paper.width, "600dpi");
    const paper_h = convertUnit(paper.unit, isLandscape ? paper.width : paper.height, "600dpi");
    const padding_w = Math.floor(convertUnit(padding.unit, padding.width, "600dpi"));
    const padding_h = Math.floor(convertUnit(padding.unit, padding.height, "600dpi"));
    if (img_w <= paper_w - padding_w && img_h <= paper_h - padding_h) {
        return {
            croppedCanvas: canvas,
            croppedPageSize: imgSize
        };
    }
    // 본격적으로 crop을 합시다.
    const newImgSize = {
        name: "cropped",
        unit: "600dpi",
        width: paper_w - padding_w,
        height: paper_h - padding_h,
    };
    const c = document.createElement("canvas");
    const pix_w = newImgSize.width - padding_w;
    const pix_h = newImgSize.height - padding_h;
    c.width = pix_w;
    c.height = pix_h;
    c.style.width = `${c.width}px`;
    c.style.height = `${c.height}px`;
    const ctx = c.getContext('2d');
    ctx.save();
    ctx.fillStyle = "rgb(255,255,255)";
    ctx.fillRect(0, 0, c.width, c.height);
    const sx = Math.floor((img_w - pix_w) / 2);
    const sy = Math.floor((img_h - pix_h) / 2);
    ctx.drawImage(canvas, sx, sy, pix_w, pix_h, 0, 0, pix_w, pix_h);
    ctx.restore();
    return {
        croppedCanvas: c,
        croppedPageSize: newImgSize
    };
}
const PAPERSIZE_THRESHHOLD = 10; // "mm"
export function determinPaperSize(mediaSize) {
    let isLandscape = false;
    let { width, height } = mediaSize;
    if (width > height) {
        const temp = height;
        height = width;
        width = temp;
        isLandscape = true;
    }
    width = convertUnit(mediaSize.unit, width, "mm");
    height = convertUnit(mediaSize.unit, height, "mm");
    // 종이 사이즈를 분류해 놓고
    const paperSizes = Object.entries(MediaSize).map(([key, paperSize]) => ({ name: key, width: paperSize.width, height: paperSize.height }));
    paperSizes.sort((a, b) => a.width - b.width);
    for (let i = 0, ln = paperSizes.length; i < ln; i++) {
        const p = paperSizes[i];
        if (width <= p.width + PAPERSIZE_THRESHHOLD) {
            return {
                sizeName: p.name,
                isLandscape
            };
        }
    }
    return {
        sizeName: paperSizes[paperSizes.length - 1].name,
        isLandscape
    };
}
//# sourceMappingURL=autoCropCanvas.js.map